import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import Ticker, { getCurrentRelationshipCount } from './Ticker';
import styles from './SocialProof.module.scss';
import { CokeLogo, DisneyLogo, NasaLogo, NikeLogo, StripeLogo } from './CompanyLogos';
import Award from './Award';
import { RelationshipsData } from '@support/hooks/use-global-contact-count';

export default function LoginSocialProof() {
  const [relationships, setRelationships] = useState<RelationshipsData | null>(null);

  useEffect(() => {
    getCurrentRelationshipCount().then(setRelationships);
  }, []);

  return (
    <div className={styles.socialProof}>
      <div className={cn(styles.section, styles.relationships, !!relationships && styles.loaded)}>
        <h4>Relationships entrusted to Clay</h4>
        <Ticker relationships={relationships} />
      </div>
      <div className={styles.section}>
        <h4>Trusted by teams at</h4>
        <div className={styles.logos}>
          <NikeLogo />
          <DisneyLogo />
          <NasaLogo />
          <StripeLogo />
          <CokeLogo />
        </div>
      </div>
      <Award />
    </div>
  );
}
